import 'aos/dist/aos.css';
import './src/css/style.css';

export function onRouteUpdate({ location, prevLocation }) {
    // check if the page has changed
    const newPageWithoutParams = location.pathname.split('?')[0];
    const previousPageWithoutParams = prevLocation ? prevLocation.pathname.split('?')[0] : null;

    if (newPageWithoutParams !== previousPageWithoutParams) {
        document.querySelector('html').style.scrollBehavior = 'auto'
        window.scroll({ top: 0 })
        document.querySelector('html').style.scrollBehavior = ''
    }
}